<template>
  <main class="u-container">
    <h1>Official USPS<sup>®</sup> Change-of-Address</h1>
    <section class="mt-3">
      <template v-if="status === 'confirmed'">
        <p class="font-bold">
          Thank you for signing up for Informed Delivery&reg;.
        </p>
        <p class="mt-2">
          Look for further email communications from USPS&reg; in the near future.
        </p>
      </template>
      <template v-else-if="status === 'alreadyConfirmed'">
        <p class="font-bold">
          For your security, this link expired after the 1st click.
        </p>
        <p class="mt-2">
          For more information and to register for Informed Delivery click <a
            class="c-link"
            href="https://informeddelivery.usps.com"
            rel="noopener noreferrer"
            target="infdel"
          >informeddelivery.usps.com</a>.
        </p>
      </template>
      <template v-else-if="status === 'error'">
        <p class="font-bold">
          We have encountered an unexpected error.
        </p>
        <p class="mt-2">
          For more information and to register for Informed Delivery click <a
            class="c-link"
            href="https://informeddelivery.usps.com"
            rel="noopener noreferrer"
            target="infdel"
          >informeddelivery.usps.com</a>.
        </p>
      </template>
    </section>
  </main>
</template>

<script>
export default {
  name: 'InformedDeliverySignup',
  data() {
    return {
      statusCode: -1,
    };
  },
  computed: {
    status() {
      switch (this.statusCode) {
        case -1: return '';

        case 0:
        case 1:
          return 'confirmed';

        case 3:
          return 'alreadyConfirmed';

        default:
          return 'error';
      }
    },
  },
  async mounted() {
    this.$coa.coaUUID = this.$route.params.coaUUID;
    this.statusCode = await this.$coa.coaInformedDeliverySignup();
  },
};
</script>
